// extracted by mini-css-extract-plugin
export default {"tableContainer":"EOI__tableContainer___Oxtu5"};